<div #mapViewNode id="mapViewNode"></div>
